var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-btn',{staticClass:"relative-position",attrs:{"flat":""}},[_c('q-icon',{staticClass:"fa fa-2x fa-th-large"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }